
const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <header>
        <h1>TERMS AND CONDITIONS</h1>
        <p className="intro">
          PLEASE READ THESE TERMS AND CONDITIONS (T&amp;C) CAREFULLY BEFORE YOU
          PROCEED. <br />
          BY PROCEEDING WITH THE ACCOUNT OPENING PROCESS, YOU INDICATE THAT YOU
          UNCONDITIONALLY ACCEPT THE TERMS AND AGREE TO ABIDE BY THEM. IF YOU DO
          NOT AGREE WITH THE TERMS, PLEASE DO NOT PROCEED WITH THE ACCOUNT
          OPENING PROCESS.
        </p>
      </header>

      <main>
        {/* Section 1 */}
        <section>
          <h2>1. Introduction</h2>
          <p>
            The T&amp;C represents an agreement between YOU and CHECKOFF FINANCE
            COMPANY LIMITED, a company registered under the laws of the Federal
            Republic of Nigeria with Registration Number 1874947 and having its
            principal place of business at 75 Mobolaji Bank Anthony Way, Ikeja,
            Lagos, Nigeria (hereinafter referred to as “Checkoff” or “We” or
            “Us” which expression shall, where the context so admits, include
            its legal representatives and assigns).
          </p>
        </section>

        {/* Section 2 */}
        <section>
          <h2>2. Definition and Interpretation</h2>
          <ul>
            <li>
              <strong>“Account”</strong> means your Checkoff Account
            </li>
            <li>
              <strong>“Application”</strong> means Checkoff’s website, its
              subdomains, mobile app, or any affiliated platform where services
              are provided.
            </li>
            <li>
              <strong>“Business Day”</strong> means any day other than Saturday,
              Sunday or public holiday when banks in Nigeria are open.
            </li>
            <li>
              <strong>“CBN”</strong> means the Central Bank of Nigeria.
            </li>
            <li>
              <strong>“Form”</strong> means the account opening form completed
              by You.
            </li>
            <li>
              <strong>“Investments”</strong> means an asset acquired with the
              goal of generating income.
            </li>
            <li>
              <strong>“Product”</strong> means Checkoff’s Bankvole product.
            </li>
            <li>
              <strong>“Representatives”</strong> means any authorized person you
              appoint in writing as your representative.
            </li>
            <li>
              <strong>“Services”</strong> means all products and services
              collectively offered by Checkoff.
            </li>
            <li>
              <strong>“T&amp;C”</strong> means these terms and conditions,
              including amendments, schedules and policies.
            </li>
            <li>
              <strong>“We/Us/Our”</strong> means Checkoff Finance Company
              Limited.
            </li>
            <li>
              <strong>“You/Your”</strong> means you, the User bound by this
              T&amp;C.
            </li>
          </ul>
        </section>

        {/* Section 3 */}
        <section>
          <h2>3. Purpose</h2>
          <p>
            The Product can be accessed via the Application. It allows you to
            make Investments and earn competitive returns on fixed tenors
            ranging from 90 days – 1 year.
          </p>
        </section>

        {/* Section 4 */}
        <section>
          <h2>4. Our Agreement</h2>
          <ol>
            <li>
              The Form together with the T&amp;C and other required supporting
              documents constitutes a binding contract between You and Us.
            </li>
            <li>
              We reserve the right to change the T&amp;C without recourse to You
              when required by legislation or our operational/business needs.
            </li>
            <li>
              Where the changes are relevant, we will advise you of the changes
              and how they affect you. You agree to check the Terms, from time
              to time.
            </li>
            <li>You agree to be bound by the latest version of the T&amp;C.</li>
            <li>The T&amp;C shall regulate the relationship between You and Us.</li>
            <li>
              We reserve the right to decline your application or revoke access
              at our discretion and without assigning any reason.
            </li>
          </ol>
        </section>

        {/* Sections 5–25 */}
        <section>
          <h2>5. Your Personal Details</h2>
          <p>
            To enable You to open an Account on the Application to access the
            Product, we require personal information such as your name, phone
            number, residential address, email, date of birth, marital status,
            occupation, employer’s name, source of funds, valid ID, and other
            details. You agree to provide true, accurate, and complete
            information. You must update it promptly in case of any changes.
          </p>
        </section>

        <section>
          <h2>6. Communication</h2>
          <p>
            You consent to us sending all notifications, notices, records,
            statements, updates, and other communications electronically. You
            will be responsible for any charges incurred for receiving them.
          </p>
        </section>

        <section>
          <h2>7. Your Instructions</h2>
          <p>
            We will only accept written instructions from you, or from your
            duly-authorized representatives. Instructions sent by courier or
            email are at your own risk. We will endeavour to execute instructions
            promptly but are not liable for delays beyond our control.
          </p>
        </section>

        <section>
          <h2>8. Connectivity</h2>
          <p>
            You are responsible for the means you use to access your Account,
            including internet, devices, and service providers.
          </p>
        </section>

        <section>
          <h2>9. Availability of the Application</h2>
          <p>
            While we strive to ensure availability, the Application may
            experience downtime, glitches, or maintenance. We do not guarantee
            24/7 access.
          </p>
        </section>

        <section>
          <h2>10. Investment and Professional Advice</h2>
          <p>
            Nothing in this Application is intended as investment advice. You are
            solely responsible for determining suitability of any investment.
            Checkoff is not liable for losses arising from unforeseen events
            beyond our control.
          </p>
        </section>

        <section>
          <h2>11. Eligibility Requirements</h2>
          <ul>
            <li>You must be 18+ or a duly incorporated entity in Nigeria.</li>
            <li>A minimum of ₦50,000 is required.</li>
            <li>
              Documents provided must be genuine; falsified information may lead
              to termination.
            </li>
          </ul>
        </section>

        <section>
          <h2>12. Fees and Charges</h2>
          <p>
            We reserve the right to apply fees as disclosed upfront before
            investment.
          </p>
        </section>

        <section>
          <h2>13. Disclosures</h2>
          <ul>
            <li>There are risks associated with investments under this product.</li>
            <li>The investments are generally short-term.</li>
          </ul>
        </section>

        <section>
          <h2>14. Taxes and Payments</h2>
          <p>
            You are liable for all taxes payable. Unless exempted, investments
            may be subject to withholding tax.
          </p>
        </section>

        <section>
          <h2>15. Death</h2>
          <p>
            Upon death, your funds shall be paid in accordance with estate laws.
          </p>
        </section>

        <section>
          <h2>16. Compliance with Applicable Law</h2>
          <p>
            As a regulated entity, Checkoff complies with anti-money laundering
            and terrorism financing laws. Your data will be subject to screening
            and profiling.
          </p>
        </section>

        <section>
          <h2>17. Email Notifications</h2>
          <p>
            You may receive email notifications regarding your investments. If
            you do not respond within 30 days, records will be deemed accurate.
          </p>
        </section>

        <section>
          <h2>18. Liabilities and Indemnities</h2>
          <p>
            You agree to indemnify Checkoff against losses arising from incorrect
            documents or information supplied by you. Liability is limited except
            in cases of gross negligence or misconduct by Checkoff.
          </p>
        </section>

        <section>
          <h2>19. Representations and Warranties</h2>
          <ul>
            <li>You are 18+ and legally capable.</li>
            <li>Your personal information is accurate.</li>
            <li>
              You will safeguard your login credentials and notify Checkoff of
              breaches.
            </li>
            <li>
              You agree to comply with all applicable laws and acknowledge
              obligations to report financial crimes.
            </li>
          </ul>
        </section>

        <section>
          <h2>20. Disclaimer of Warranties</h2>
          <p>
            Checkoff is not responsible for losses due to failure of systems,
            force majeure, or issues beyond our control.
          </p>
        </section>

        <section>
          <h2>21. Termination</h2>
          <p>
            The agreement remains until investment maturity. Both parties may
            terminate under specific conditions. Early termination by you attracts
            a fee of 25% of accrued interest.
          </p>
        </section>

        <section>
          <h2>22. Confidentiality</h2>
          <p>
            Your information is confidential except as required by law, regulatory
            authorities, or with your consent.
          </p>
        </section>

        <section>
          <h2>23. Third Party Service Providers</h2>
          <p>
            We may use third-party providers. We are not responsible for their
            practices. If you do not accept their terms, do not proceed with
            Checkoff services.
          </p>
        </section>

        <section>
          <h2>24. Governing Law and Dispute Resolution</h2>
          <p>
            This T&amp;C is governed by Nigerian law. Disputes shall be resolved
            through Mediation at the Lagos Multi-Door Courthouse.
          </p>
        </section>

        <section>
          <h2>25. Severability</h2>
          <p>
            If any provision is deemed illegal or unenforceable, it will be
            modified or removed, while the rest remains in effect.
          </p>
        </section>

        {/* Section 26 */}
        <section>
          <h2>26. Contact Us</h2>
          <p>
            For questions, contact us at: <br />
            <a href="mailto:investment@checkoff.finance">
              investment@checkoff.finance
            </a>{" "}
            or{" "}
            <a href="mailto:customerservice@checkoff.loans">
              customerservice@checkoff.loans
            </a>
          </p>
        </section>
      </main>

        <p>
          YOU CONFIRM THAT YOU HAVE READ, UNDERSTOOD AND AGREED TO THE ABOVE
          TERMS AND CONDITIONS. BY PROCEEDING TO OPEN THE ACCOUNT, YOU INDICATE
          THAT YOU UNCONDITIONALLY ACCEPT THESE TERMS AND AGREE TO ABIDE BY
          THEM.
        </p>
    </div>
  );
};

export default TermsAndConditions;
